import React from 'react';
import { Login,EmbedScreenCheck } from './screens';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import ProtectedRoute from './components/ProtectedRoute';

const App = () => {
  return (
    <>
      <Router>
      <Routes>
        <Route  exact path={`/`} element={<Navigate to="/dashboards" replace />}></Route>
      </Routes>
      <Routes>
        <Route  exact path={`/login`} element={<Login/>}></Route>
      </Routes>
      <Routes>
        <Route element={<ProtectedRoute />}>
            <Route  exact path={`/dashboards`} element={<EmbedScreenCheck/>}/>
        </Route>
      </Routes>
    </Router>
    </>
  )
}

export default App;